import { Game } from '../../../features/game/types/Game'

export const minSearchTermLength = 2
export const searchDebounceMs = 500
export const defaultSelectorMarketIso = 'us'

export const canSearchGames = (term: string, conventionalSubgenreId: string) => term.trim().length >= minSearchTermLength || !!conventionalSubgenreId

export const getMarketPowerscore = (game: Game, marketIso: string): number => game.gpsPerMarket?.[marketIso] ?? 0

const byLowerCaseName = (a: Game, b: Game) => {
  const nameA = (a.name ?? '').toLowerCase()
  const nameB = (b.name ?? '').toLowerCase()
  return nameA < nameB ? -1 : nameA > nameB ? 1 : 0
}

// Unless all games are allowed, only games analysed in the market (POWERSCORE above 0) are offered, as in legacy.
export const filterSearchedGames = (games: Game[], marketIso: string, allowAllGames: boolean): Game[] =>
  (allowAllGames ? [...games] : games.filter((game) => getMarketPowerscore(game, marketIso) > 0)).sort(byLowerCaseName)

export const isGameSelected = (selected: Game[], game: Game) => selected.some((selectedGame) => selectedGame.id === game.id)

export const toggleGameSelection = (selected: Game[], game: Game, maxSelected: number): Game[] => {
  if (isGameSelected(selected, game)) return selected.filter((selectedGame) => selectedGame.id !== game.id)
  return selected.length < maxSelected ? [...selected, game] : selected
}
